export default "__VITE_ASSET__982547af__"